"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ShuttleIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ShuttleIcon, _PureComponent);

  function ShuttleIcon() {
    _classCallCheck(this, ShuttleIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShuttleIcon).apply(this, arguments));
  }

  _createClass(ShuttleIcon, [{
    key: "render",
    value: function render() {
      var color = this.props.color;
      return _react2.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50.26 35.182",
        style: {
          fill: color,
          enableBackground: 'new 0 0 63 63'
        }
      }, _react2.default.createElement("path", {
        className: "a",
        d: "M49.386,46.03,38.825,33.356A3.77,3.77,0,0,0,35.929,32H2.513A2.513,2.513,0,0,0,0,34.513V57.13a2.513,2.513,0,0,0,2.513,2.513H5.026a7.539,7.539,0,1,0,15.078,0H30.156a7.539,7.539,0,1,0,15.078,0h2.513A2.513,2.513,0,0,0,50.26,57.13V48.443A3.773,3.773,0,0,0,49.386,46.03ZM5.026,44.565V37.026h7.539v7.539Zm7.539,18.847a3.769,3.769,0,1,1,3.769-3.769A3.769,3.769,0,0,1,12.565,63.412ZM25.13,44.565H17.591V37.026H25.13ZM37.695,63.412a3.769,3.769,0,1,1,3.769-3.769A3.769,3.769,0,0,1,37.695,63.412ZM30.156,44.565V37.026H35.34l6.282,7.539Z",
        transform: "translate(0 -32)"
      }));
    }
  }]);

  return ShuttleIcon;
}(_react.PureComponent);

exports.default = ShuttleIcon;